import { render, staticRenderFns } from "./sdproduct13.vue?vue&type=template&id=e5cf9520&scoped=true"
import script from "./sdproduct13.vue?vue&type=script&lang=js"
export * from "./sdproduct13.vue?vue&type=script&lang=js"
import style0 from "./sdproduct13.vue?vue&type=style&index=0&id=e5cf9520&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5cf9520",
  null
  
)

export default component.exports